import React from 'react';

import { useSelector } from 'react-redux';

import { isMobile } from 'react-device-detect';
import NavMarker from './NavMarker';
import HotspotMarker from './HotspotMarker';
import { createSelector } from '@reduxjs/toolkit';

const storeDataSelector = createSelector(
	[(state) => state?.storeData || {}],
	(storeData) => ({
		skipProductIfNotInDBFromConfig:
			storeData?.hotspots_configuration?.hide_if_product_not_in_db ||
			false,
		tooltipConfig: storeData?.styling?.tooltips || {},
	}),
);

const roomObjectsSelector = createSelector(
	[(state) => state?.roomObjects || {}],
	(roomObjects) => {
		const roomObjectsArr = Object.keys(roomObjects).map(
			(key) => roomObjects[key],
		);

		return roomObjectsArr.map((item) => ({
			_id: item._id.$oid,
			type: item.type,
			hotspotType: item?.props?.hotspot_type,
			showOnlyOn: item?.show_only_on,
			isProductHotspot: item?.props?.hotspot_type === 'product',
			productInDb: item?.product_in_db,
		}));
	},
);

const RoomObjects = ({ sceneId, ...props }) => {
	const roomObjects = useSelector((state) => state?.roomObjects || []);

	const { skipProductIfNotInDBFromConfig, tooltipConfig } =
		useSelector(storeDataSelector);

	const roomObjectsArr = Object.keys(roomObjects).map(
		(key) => roomObjects[key],
	);

	const roomObjectsMinimized = useSelector(roomObjectsSelector);

	if (roomObjectsArr.length <= 0) return null;

	return roomObjectsMinimized.map((item) => {
		if (item?.isProductHotspot) {
			const itemNotInDB = item?.productInDb === false;
			if (skipProductIfNotInDBFromConfig && itemNotInDB) {
				return null;
			}
		}

		if (
			(isMobile && item.showOnlyOn !== 'desktop') ||
			(!isMobile && item.showOnlyOn !== 'mobile')
		) {
			if (item.type === 'NavMarker') {
				return (
					<NavMarker
						hotspotId={item._id}
						key={item._id}
						{...props}
						tooltipConfig={tooltipConfig}
						sceneId={sceneId}
					/>
				);
			}
			return (
				<HotspotMarker
					hotspotId={item._id}
					key={item._id}
					tooltipConfig={tooltipConfig}
					{...props}
				/>
			);
		}
	});
};

RoomObjects.propTypes = {};

export default RoomObjects;
